import { QueryRequestHelper } from "@_common/query-request-helper";
import { getSmartFilterCategoryOfLawList } from "@services/list-management.service";
import { getValue } from "@utils/lodash";

export const getSpecificCategoryLawById = async (id: string) => {
  if (id) {
    try {
      let payload = {
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterCategoryOfLawList(queryRequest);
      if (resp) {
        return getValue(
          resp,
          `data.stateCategoryOfLaw[${0}].category_of_law.id`,
          ""
        );
      }
    } catch (error) {}
  } else {
    return null;
  }
};
